module.exports = __webpack_public_path__ + "static/media/RV-removebg-preview.61d9b9f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/png-images/RV-removebg-preview.png
// module id = 3029
// module chunks = 0